import axios from 'axios'

export default {
  namespaced: true,
  state: {
    videos: sessionStorage.getItem('videos') ? JSON.parse(sessionStorage.getItem('videos')) : false
  },
  mutations: {
    fetch(state, videos) {
      state.videos = videos
      sessionStorage.setItem('videos', JSON.stringify(videos))
    },
    reset(state) {
      state.videos = false
      sessionStorage.removeItem('videos')
    }
  },
  actions: {
    async fetch({
      commit,
      state
    }, site) {
      if (!state.videos) {
        const res = await axios({
          url: '/common/cms/video/?audit=1&visible=1',
          method: 'GET',
          data: {
            pageSize: 1000,
            visible: 1,
            audit: 1
          },
          headers: {
            'X-SITE-ID': site
          }
        })
        commit('fetch', res.data.data)
      }
    },
    reset({
      commit
    }) {
      commit('reset')
    }
  },
  getters: {
    videos: (state) => {
      return state.videos || []
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/VideosStore.js